import { EncryptStorage } from 'encrypt-storage'

export const encryptStorage = new EncryptStorage(import.meta.env.VITE_ENCRYPTION_KEY, {
  prefix: '@encryption',
})
